// extracted by mini-css-extract-plugin
export default {"select":"select_select__KwzC1","error-select":"select_error-select__YYkKp"};